const POSITIVE = new Set(['approved', 'complete']);
const NEGATIVE = new Set(['refunded', 'partially_refunded', 'canceled', 'chargeback', 'expired', 'blocked', 'dispute']);

// Badges do design system: quadrados (sem radius), uppercase, tracking
// largo — mesmo padrão de .badge em design-system.html.
export function StatusBadge({ status, label }: { status: string; label: string }) {
  const tone = POSITIVE.has(status) ? 'positive' : NEGATIVE.has(status) ? 'negative' : 'neutral';

  const classes = {
    positive: 'bg-success text-white',
    negative: 'bg-error text-white',
    neutral: 'bg-stone text-slate dark:bg-white/10 dark:text-white/70',
  }[tone];

  return (
    <span className={`inline-block px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider ${classes}`}>{label}</span>
  );
}
